type TokenGetter = () => Promise<string | undefined | null>;

const TOKEN_CACHE_TTL_MS = 30_000;

let tokenGetter: TokenGetter | null = null;
let cachedToken: { token: string; fetchedAt: number } | null = null;
let inFlightTokenPromise: Promise<string | null> | null = null;

export function clearAuthTokenCache(): void {
  cachedToken = null;
  inFlightTokenPromise = null;
}

export const authTokenHolder = {
  setTokenGetter(getter: TokenGetter | null): void {
    tokenGetter = getter;
  },

  async getToken(): Promise<string | null> {
    if (
      cachedToken &&
      Date.now() - cachedToken.fetchedAt < TOKEN_CACHE_TTL_MS
    ) {
      return cachedToken.token;
    }

    if (inFlightTokenPromise) {
      return inFlightTokenPromise;
    }

    if (!tokenGetter) {
      return null;
    }

    inFlightTokenPromise = (async () => {
      try {
        const token = await tokenGetter!();
        const normalizedToken = token ?? null;
        if (normalizedToken) {
          cachedToken = { token: normalizedToken, fetchedAt: Date.now() };
        }
        return normalizedToken;
      } catch {
        return null;
      } finally {
        inFlightTokenPromise = null;
      }
    })();

    return inFlightTokenPromise;
  },
};
